import React from "react";
import Link from '@mui/material/Link';

export const LoginButton = () => {
  return (
    <Link to="/login" href="/login">Login</Link>
  );
};
